import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap, switchMap } from 'rxjs/operators';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { StorageService } from './storage';
import { apiUrls } from 'src/environments/environment';
import { Router } from '@angular/router';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { UserService } from './User.service';

const TOKEN_KEY = 'my-token';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  // Init with null to filter out the first value in a guard!
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  token = '';
  tokenRefresh = '';

  // guest logs
  guestEmail = 'guest@mail.com';
  guestPassword = 'guest123456789';

  constructor(private http: HttpClient, private router: Router, private loader: LoaderComponent,
     private user: UserService) {

  }

  get tokenName() {
    return TOKEN_KEY;
  }

  async refreshToken(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(apiUrls.refreshToken, { refresh_token: this.tokenRefresh }).subscribe(
        (data: any) => {
          this.token = data.token;
          this.tokenRefresh = data.refresh_token;
          StorageService.setStorage(
            TOKEN_KEY,
            JSON.stringify(
              {
                token: data.token,
                refreshToken: data.refresh_token
              }
            )
          );
          resolve(data.token);
        },
        async (err) => {
          this.token = '';
          this.tokenRefresh = '';
          await StorageService.removeStorage(TOKEN_KEY);
          this.loader.dismiss();
          this.router.navigateByUrl('/home', { replaceUrl: true });
        })
        ;
    });
  }

  async loadToken() {
    console.log('on tente de laod le token');
    console.log(this.token);
    console.log(this.tokenRefresh);
    if (this.token === '' && this.tokenRefresh === '') {
      const token = await StorageService.getStorage(TOKEN_KEY);


      console.log('token value');
      console.log(token);
      if (token) {
        const jwtToken = await JSON.parse(token);
        this.token = jwtToken.token;
        this.tokenRefresh = jwtToken.refreshToken;
        this.isAuthenticated.next(true);
      } else {
        this.isAuthenticated.next(false);
      }
    } else {
      this.isAuthenticated.next(true);
    }
  }

  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post(apiUrls.login, credentials).pipe(
      map((data: any) => data),
      switchMap(data => {
        this.token = data.token;
        this.tokenRefresh = data.refresh_token;
        return from(StorageService.setStorage(
          TOKEN_KEY,
          JSON.stringify({ token: data.token, refreshToken: data.refresh_token })
        )
        );
      }),
      tap(_ => {
        this.isAuthenticated.next(true);
      })
    );
  }

  register(credentials: { email: string; lastname: string; firstname: string; password: string; postalCode?: string }): any {
    return this.http.post(apiUrls.register,
      {
        email: credentials.email,
        name: credentials.lastname,
        firstName: credentials.firstname,
        postalCode: credentials?.postalCode ? credentials.postalCode : '',
        password: credentials.password
      });
  }

  async logout(): Promise<void> {
    this.token = '';
    this.tokenRefresh = '';
    this.isAuthenticated.next(false);
    this.user.user = undefined;
    this.user.deleteGuestUser();
    await StorageService.removeStorage('current-user');
    return await StorageService.removeStorage(TOKEN_KEY);
  }
}

